// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1TeuK","rootSuccess":"CompleteLink_rootSuccess__24DDt","rootFailure":"CompleteLink_rootFailure__OS6kz","isDisabled":"CompleteLink_isDisabled__4TXa_"};